import { ConfigurationParameters, Configuration, SocietesApi } from '../../openApi/ApiSociete';

/**
 * Configuration
 */

export function buildSocieteRedux(configSociete: ConfigurationParameters) {
    const societeConfiguration = new Configuration(configSociete);

    const societeApi = new SocietesApi(societeConfiguration);

    return {
        serviceConfiguration: societeConfiguration,
        serviceConfigurationParameters: configSociete,
        apis: {
            societeApi,
        },
        thunks: {},
        slices: {},
        fetchItems: {},
        getItems: {},
        models: {},
    };
}
